module.exports = __webpack_public_path__ + "img/DE00803.1f9a1abe.png";